import React, { useEffect, useState, useRef } from "react";

import { auth, firebase } from "../../Firebase/config";

import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import axios from "axios";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import "../Messages.css";

export default function Phonelessstudents({
  currentclass,
  activename,
  setSelectedclass,
  activeid2,
  activename2,
  selectedclass,
  currentstudent,
  setCurrentstudent,
  studentidd,
  parentlanguagecode,
  id2,
  temparray,
  activeid,
  id,
  role,
  assignmentname,
  assignmentid,
  accesstokenn,
  refreshtokenn,
  expirydatee,

  gccompare,
  gcdatasent,
  gctimesent,
  gc1title,
  gc1compare,
  gc1datasent,
  gc1timesent,
  sid,
  only2studentid,
  studentid,
  setSid, setSelectedclass1,
  setShowpersonal, showpersonal, nameinobject, gradereceived, googleclassroomid, averageofgradeswithzeros, averageofgrades, lowscore, highscore,
  gc1assignmentMaterials, getsyllabus
}) {


  // Log key props before rendering


  // // Log which branch of conditional rendering is being hit
  // let renderBranch = "";
  // if (
  //   (typeof gcdatasent != "undefined" && typeof gc1datasent == "undefined") ||
  //   (typeof gcdatasent != "undefined" && typeof gc1datasent != "undefined" && gccompare > gc1compare)
  // ) {
  //   renderBranch = "gcdatasent branch";
  // } else if (
  //   (typeof gc1datasent != "undefined" && typeof gcdatasent == "undefined") ||
  //   (typeof gc1datasent != "undefined" && typeof gcdatasent != "undefined" && gc1compare > gccompare)
  // ) {
  //   renderBranch = "gc1datasent branch";
  // } else {
  //   renderBranch = "fallback branch";
  // }
  

  const [lasttwomonths, setlasttwomonths] = useState([]);

  const [searchingstate, setSearchingstate] = useState(false);
  const [aallpasses, setAallpasses] = useState();

  const [filteredstates, setFilteredstates] = useState([]);

  const [activpasses, setActivpasses] = useState([]);
  const [update, setUpdate] = useState();

  const [changehasbeenmade, setChangehasbeenmade] = useState();
  const [endtime, setEndtime] = useState();
  const [begintime, setBegintime] = useState();

  const [revise, setRevise] = useState();

  const [passesbetween, setPassesbetween] = useState();

  const [currentclass2, setCurrentclass2] = useState();
  const [activeid22, setActiveid2] = useState();

  const [website, setWebsite] = useState();
  const [whatparentssee, setWhatpareentseee] = useState();
  const [thispage, setThispage] = useState();

  const [selectedassignment, setSelectedassignment] = useState(null);
  const [currenttoptenarray, setCurrenttoptenarray] = useState("");
  const [showSyllabusModal, setShowSyllabusModal] = useState(false);

  const navigate = useNavigate();

  console.log("gcdatasent:", gcdatasent);
  console.log("gc1datasent:", gc1datasent);
  console.log("gccompare:", gccompare);
  console.log("gc1compare:", gc1compare);
  console.log("showpersonal:", showpersonal);
  console.log("selectedclass:", selectedclass);
  console.log("selectedassignment:", selectedassignment);

   const hasGcdatasent = Array.isArray(gcdatasent) && gcdatasent.length > 0;
  const hasGc1datasent = Array.isArray(gc1datasent) && gc1datasent.length > 0;

  // Decide which branch to render using real data presence (not just typeof)
  let renderBranch = "";
  if (hasGcdatasent && !hasGc1datasent) {
    renderBranch = "gcdatasent branch";
  } else if (hasGc1datasent && !hasGcdatasent) {
    renderBranch = "gc1datasent branch";
  } else if (hasGcdatasent && hasGc1datasent) {
    // both present — use compare values (guard against undefined)
    renderBranch = (Number(gccompare || 0) > Number(gc1compare || 0)) ? "gcdatasent branch" : "gc1datasent branch";
  } else {
    renderBranch = "fallback branch";
  }
  console.log("Rendering branch:", renderBranch);

  useEffect(() => {
    console.log("useEffect triggered for top ten calculation");
    console.log("selectedassignment:", selectedassignment);
    console.log("gcdatasent:", gcdatasent);

    if (selectedassignment !== null && gcdatasent && gcdatasent.length > 0) {
      const assignmentId = selectedassignment.assignmentId;
      console.log("assignmentId:", assignmentId);

      const studentsWithAssignment = gcdatasent
        .map(student => {
          if (!student.grades) {
            console.log("Student missing grades:", student);
            return null;
          }
          const gradeObj = student.grades.find(g => g.assignmentId === assignmentId);
          if (gradeObj) {
            return {
              name: `${student.profile.firstName} ${student.profile.lastName ? student.profile.lastName.charAt(0) + '.' : ''}`,
              grade: gradeObj.grade,
              maxPoints: gradeObj.maxPoints,
              studentId: student.profile.firebasestudentid,
              id: student.profile.firebasestudentid,
              profile: student.profile // for rendering
            };
          }
          return null;
        })
        .filter(Boolean);

      console.log("studentsWithAssignment after mapping:", studentsWithAssignment);

      studentsWithAssignment.sort((a, b) => b.grade - a.grade);

      let itemsToShow = gcdatasent.length < 5 ? gcdatasent.length : gcdatasent.length > 13 ? 10 : 5;
      const topTen = studentsWithAssignment.slice(0, itemsToShow);

      console.log("Top Ten Array:", topTen);

      setCurrenttoptenarray(topTen);
    } else {
      console.log("No selectedassignment or gcdatasent is empty");
      setCurrenttoptenarray([]);
    }
  }, [selectedassignment, gcdatasent]);



 const selectHandler = (value, i) => {
  if (value && value.profile.firebasestudentid != sid) {
    setSelectedclass(value);
  } else {
    // use null instead of empty string to avoid type confusion
    setSelectedclass(null);
  }
};

console.log(gcdatasent, gccompare, gc1datasent, gc1compare, showpersonal, selectedclass, selectedassignment, "gcdatasent, gccompare, gc1datasent, gc1compare, showpersonal, selectedclass, selectedassignment" );
  // Helper: get view-only link for Google Doc
  const getViewOnlyLink = (link) => {
    if (!link) return '';
    // Replace /edit or /edit?... with /preview
    return link.replace(/\/edit(\?.*)?$/, '/preview');
  };

  return (
    <div className="inner123">
      {(hasGcdatasent && (!hasGc1datasent || Number(gccompare || 0) > Number(gc1compare || 0))) ? (
         
        <>

          {showpersonal == false && gcdatasent && gcdatasent.length > 0 && gcdatasent[0] && gcdatasent[0].grades ? (
            <div className="section5922ab" onClick={() => setShowpersonal(true)} style={{ fontFamily: "fantasy" }}>
              Top {gcdatasent.length < 5 ? gcdatasent.length : gcdatasent.length > 13 ? 10 : 5} Averages<br />Recent Assignments<br />  <span style={{ marginTop: "0px", fontSize:  'clamp(15px, 3vw, 22px)', fontFamily: "fantasy" }}>(See {nameinobject}'s scores)</span>
            </div>
          ) : null}

          {showpersonal == false && (() => {
            // Show first 2 items if 1 + 1 == 2, else show first 1 item
            const itemsToShow = gcdatasent.length < 5 ? gcdatasent.length : gcdatasent.length > 13 ? 10 : 5;
            return gcdatasent.slice(0, itemsToShow).map((item, index) => (
              <React.Fragment key={item.id || index}>
                <div >
                  <div
                    className={(item.profile.firebasestudentid == studentid) || (item.profile.firebasestudentid == only2studentid) ? "passstart" : "passstart259"}>

                    <span style={{ float: "left", marginLeft: 10 }}>
                      {item.summary && item.summary.ranking}.
                    </span>

                    {item.profile.firstName} {item.profile.lastName ? ` ${item.profile.lastName.charAt(0)}.` : ""}

                    {item.summary.averageGrade ? <span style={{ float: "right", paddingRight: 7 }}>
                      {Math.round(item.summary.averageGrade * 10) / 10}%
                    </span> : <span style={{ float: "right", paddingRight: 7, color: "#013469" }}>
                      {Math.round(item.summary.averageGrade * 10) / 10}%
                    </span>}



                    <br></br>

                  </div>
                </div>
              </React.Fragment>
            ));
          })()}

          {showpersonal == true && selectedclass && selectedclass.grades && selectedassignment == null ? (
            <div className="section5922ab" onClick={() => setShowpersonal(false)} style={{ fontFamily: "fantasy" }}>
              {selectedclass.profile ? selectedclass.profile.firstName : ""}'s Recent Assignments  <br></br> 

              <span style={{ marginTop: "0px", fontSize: 'clamp(15px, 3vw, 22px)', fontFamily: "fantasy" }}>(Click to See Top {gcdatasent.length < 5 ? gcdatasent.length : gcdatasent.length > 13 ? 10 : 5} Averages)</span>
            </div>
          ) : showpersonal == true && selectedclass && selectedclass.grades && selectedassignment !== null ? <div className="section5922ab" onClick={() => setSelectedassignment(null)} style={{ fontFamily: "fantasy" }}>
            "{selectedassignment?.assignmentTitle || ""}"<br></br>

             <span style={{ marginTop: "0px", fontSize: 'clamp(15px, 3vw, 22px)', fontFamily: "fantasy" }}>(Top {gcdatasent.length < 5 ? gcdatasent.length : gcdatasent.length > 13 ? 10 : 5} Students) </span>
          </div> : null}
          {showpersonal == true && selectedclass && selectedclass.grades && selectedassignment == null &&
            selectedclass.grades.map((item, index) => (
              <React.Fragment key={item.id || index}>
                <div className="passstart" onClick={() => {
                  console.log("Clicked assignment:", item);
                  setSelectedassignment(item);
                }}>
                  <span style={{ fontWeight: "bold" }}>
                    {item.assignmentTitle}
                  </span>
                  <br />
                  {item.grade}/{item.maxPoints}
                </div>
              </React.Fragment>
            ))}
          {showpersonal == true && selectedassignment !== null && (
            <div>
              {currenttoptenarray.map((item, index) => (
                <div
                  key={item.id || index}
                  className={(item.studentId == studentid || item.studentId == only2studentid) ? "passstart" : "passstart259"} onClick={() => setSelectedassignment(null)}
                >
                  <span style={{ float: "left", marginLeft: 10 }}>
                    {index + 1}.
                  </span>
                  {item.profile.firstName} {item.profile.lastName ? ` ${item.profile.lastName.charAt(0)}.` : ""}
                  <span style={{ float: "right", paddingRight: 7 }}>
                    {item.grade}/{item.maxPoints}
                  </span>
                  <br />
                </div>
              ))}
            </div>
          )}
        </>
      ) :  (hasGc1datasent && (!hasGcdatasent || Number(gc1compare || 0) > Number(gccompare || 0))) ? (
        <>

          {showpersonal == false ? <div className="section5922ab" onClick={() => setShowpersonal(true)} style={{ fontFamily: "fantasy" }}>{gc1title}<br></br> Top {gc1datasent.length < 5 ? gc1datasent.length : gc1datasent.length > 13 ? 10 : 5} Scores </div> : null}

          {/* Syllabus Button (shows if getsyllabus exists) */}

          {showpersonal == false && (() => {
            let itemsToShow = gc1datasent.length < 5 ? gc1datasent.length : gc1datasent.length > 13 ? 10 : 5;
            return gc1datasent.slice(0, itemsToShow).map((item, index) => (
              <React.Fragment key={item.id || index}>

                <div onClick={() => setShowpersonal(true)}>
                  <div
                    className={(item.id == studentid) || (item.id == only2studentid) ? "passstart" : "passstart259"}
                  >
                    <div onClick={() => console.log("select")}>
                      <span style={{ float: "left", marginLeft: 10 }}>
                        {index + 1}.
                      </span>
                      {(() => {
                        const nameParts = item.name.split(' ');
                        if (nameParts.length > 1) {
                          return `${nameParts[0]} ${nameParts[1].charAt(0)}.`;
                        }
                        return item.name; // Return the original name if there's no space
                      })()}
                      {item.grade > 60 ? <span style={{ float: "right", paddingRight: 7 }}>
                        {item.grade}%
                      </span> : <span style={{ float: "right", paddingRight: 7, color: "#013469" }}>{item.grade}%</span>}
                    </div>
                    <div></div>
                       <div></div>
                  </div>
                </div>
              </React.Fragment>
            ));
          })()}

   {typeof getsyllabus !== "undefined" && getsyllabus && getsyllabus.documentLink && showpersonal == false && (
            <>
            <br></br>
              <div className="section5922ab">
                <button
                  onClick={() => setShowSyllabusModal(true)}
                  style={{
                    display: "inline-block",
                    marginTop: "4px",
                    marginBottom: "4px",
                    padding: "8px 16px",
                    background: "#0a84ff",
                    color: "#fff",
                    textDecoration: "none",
                    border: "none",
                    borderRadius: "4px",
                    fontSize: "14px",
                    cursor: "pointer"
                  }}
                >
                  📄 View Syllabus
                </button>
              </div>
            </>
          )}



          {showpersonal == true ? <div className="section5922ab" onClick={() => setShowpersonal(false)} style={{ fontFamily: "fantasy" }}>{gc1title}</div> : null}


          {showpersonal == true ? <div onClick={() => setShowpersonal(false)}>

            <div
              style={{
                position: "relative",
                width: "100%",
                height: 20,
                borderRadius: 0,
                margin: "20px 0",
                background: "yellow",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              {/* gradereceived */}


              {/* averageofgrades */}
              <div
                style={{
                  position: "absolute",
                  left: `${(averageofgrades - lowscore) / (highscore - lowscore) * 100}%`,
                  top: 0,
                  height: "100%",
                  width: 12,
                  background: "#FF0000",
                  zIndex: 2
                }}
                title={`Class Avg (no 0s): ${Math.round(averageofgrades * 10) / 10}%`}
              >

              </div>

              <div
                style={{
                  position: "absolute",
                  left: `${(gradereceived - lowscore) / (highscore - lowscore) * 100}%`,
                  top: 0,
                  height: "100%",
                  width: 12,
                  background: "#00FF00",
                  zIndex: 3
                }}
                title={`${nameinobject}'s grade: ${gradereceived}%`}
              >

              </div>

            </div>

            <br></br>
            {nameinobject}'s grade: <span style={{
              color: "#00FF00"
            }}>{gradereceived}%</span><br></br><br></br>High Score: {highscore}%<br></br><br></br>Low Score: {lowscore}% <br></br><br></br>Class Average: <span style={{
              color: "red"
            }}>{Math.round(averageofgrades * 10) / 10}%</span> <br></br><br></br> <span style={{ fontStyle: 'italic' }}>(Click to View Class Scores)</span> <br></br>
          </div> : null}
        </>
      ) : (<div>
        <div onClick={() => console.log("select")}>
          Nothing has been saved to this page.
        </div>
        <div></div>
      </div>)}
      <br></br>


      {typeof getsyllabus !== "undefined" && getsyllabus && getsyllabus.documentLink && showpersonal == true && (
        <>
      
          <div className="section5922ab">
            <button
              onClick={() => setShowSyllabusModal(true)}
              style={{
                display: "inline-block",
                marginTop: "4px",
                marginBottom: "4px",
                padding: "8px 16px",
                background: "#0a84ff",
                color: "#fff",
                textDecoration: "none",
                border: "none",
                borderRadius: "4px",
                fontSize: "14px",
                cursor: "pointer"
              }}
            >
              📄 View Syllabus
            </button>
          </div>
          <br></br><br></br><br></br><br></br><br></br>
        </>
      )}
      
      {/* Syllabus Modal (view-only Google Doc) */}
      {showSyllabusModal && typeof getsyllabus !== "undefined" && getsyllabus && getsyllabus.documentLink && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "20px",
            maxWidth: "90%",
            maxHeight: "90%",
            position: "relative",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            overflowY: "auto"
          }}>
            <button
              onClick={() => setShowSyllabusModal(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                background: "none",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: "#333"
              }}
            >
              ✕
            </button>
            <iframe
              width="800"
              height="450"
              src={getViewOnlyLink(getsyllabus.documentLink)}
              title={getsyllabus.documentTitle || "Syllabus"}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                borderRadius: "4px"
              }}
            ></iframe>
            <p style={{ marginTop: "15px", fontSize: "12px", color: "#666" }}>
              <a
                href={getsyllabus.documentLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0a84ff" }}
              >
                Open in Google Docs
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

/* <View>
<div
  style={
    item.id === idselected ? styles.selected : styles.unselected
  }
  onClick={() => selectHandler(item)}>
  <div style={styles.end}>{item.firstname} {item.lastname}{'\n'}{new Date(item.leftclass).toString().substr(4, 11)} @ {item.timeleftclass}{'\n'}{item.comingfrom} -{item.destination} - {item.timeallowedonpass} min.</div>
</div>


</View> */